<template>
  <div class="wrap-table-order" ref="orderList">
    <table class="table">
      <thead>
        <tr>
          <th v-translate>Qty</th>
          <th v-translate>Item</th>
          <th v-translate>ID Staff</th>
          <th v-translate>Price / Item</th>
          <th v-translate>Amount</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <!-- Previous Order Items and Separators -->

        <template v-if="previousOrder.length">
          <template v-for="(item, itemIndex) in previousOrder">
            <tr v-if="previousOrderSeparators.includes(itemIndex)" class="tr-separator">
              <td colspan="6"></td>
            </tr>
            <bill-item
              :item="item"
              :itemIndex="itemIndex"
              :view="'previous'"
              :showStaff="previousOrderSeparators.includes(itemIndex)" />
            <bill-item-note :note="item.note" :promotion="item.promotion" :start="item.timeStart" :end="item.timeEnd" :view="'normal'" />
          </template>
          <tr class="tr-separator"><td colspan="6"></td></tr>
        </template>

        <!-- Current Order Items -->
        <template v-for="(item, itemIndex) in billItems">
          <bill-item :item="item" :view="'normal'" :itemIndex="itemIndex"/>
          <bill-item-note :note="item.note" :promotion="item.promotion" :start="item.timeStart" :end="item.timeEnd" :view="'normal'" />
        </template>
      </tbody>
    </table>
  </div>
  <!-- /.wrap-table-order -->
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BillItem from '@/components/BillItem';
import BillItemNote from '@/components/BillItemNote.vue';

export default {
  name: 'OrderList',
  components: {
    BillItem,
    BillItemNote,
  },
  computed: {
    billItems() { return this.getMap('bill', true).billItems; },
    previousOrder() { return this.getMap('previousOrder', true); },
    ...mapGetters(['previousOrderSeparators']),
  },
  watch: {
    billItems(value) {
      setTimeout(() => { this.$refs.orderList.scrollTop += this.$refs.orderList.scrollHeight; }, 0);
    },
  },
};
</script>
